let apiBase = "";
let IsEstelamCodeMeli = "";
let IsrequiredEstelamSabtAhval = "";
let IsFixVarizGorohi = false;
let IsFixVarizGorohiHasJarime = "";
let MablaghKarmozdRial = 0;
let IsAnbohSaz = "false";
let IsCardexPay = "";
let MablaghEftetahHesab = 0;
let NoeIdPishFarz = 0;
let HasEmza = false;
let IsEstelamSheba = false;
let VahedPool = "";
let IsLinkPay = false;
let ActivePasswordSecurityMode;
let isLoadingAppSettings = false;
let appSettingsPromise = null;
let loginDefaultImageMode;

let EnableRobot = "";
let botToken;
let botUserName;
let botAboutUsText;

import moment from "moment-jalaali";
let IsNetpa = "";
let URL = "";
let ApiServiceUrl = "";
let GetTasveye = { sumKarmozd: 0, mabTasveye: 0 };
const mabalegh = [
  "Mande",
  "Mablagh",
  "GhabelBardasht",
  "mablagh",
  "Bedeh",
  "Bestan",
  "MablaghSharj",
  "HodudGheymat",
  "Mab",
  "bedeh",
  "bestan",
  "mabEnteghal",
  "mabPardaxtShodeGhest",
  "mandeGhest",
  "mande",
  "ghabelBardasht",
  "MabVarizi",
  "mablaghGhestVam",
  "SumBedeh",
  "SumBestan",
];
const Adad = [
  "Mande",
  "Mablagh",
  "GhabelBardasht",
  "mablagh",
  "Bedeh",
  "Bestan",
  "MablaghSharj",
  "bedeh",
  "bestan",
  "mabEnteghal",
  "mabPardaxtShodeGhest",
  "mandeGhest",
  "mande",
  "ghabelBardasht",
];
const pn = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
const en = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
import Num2persian from "num2persian";
const GlobalPlugin = {
  install(Vue) {
    // مقداردهی اولیه apiBase از sessionStorage
    if (typeof sessionStorage !== "undefined") {
      const storedApiBase = sessionStorage.getItem("NetPaApi");
      if (storedApiBase) {
        apiBase = storedApiBase;
      }
    }

    // We call Vue.mixin() here to inject functionality into all components.
    //Public alert
    Vue.prototype.$GetAppsettings = function () {
      if (isLoadingAppSettings && appSettingsPromise) {
        return appSettingsPromise; // اگر در حال لود است، همان Promise را برگردان
      }

      isLoadingAppSettings = true;

      var axios = require("axios");
      const config = {
        method: "GET",
        url: `${window.location.origin}/appSettings.json?nocache=${Date.now()}`,
        headers: {
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "Content-Type": "application/json",
        },
      };

      appSettingsPromise = axios(config)
        .then((response) => {
          apiBase = response.data.NetPaApi || apiBase;
          // ذخیره در sessionStorage برای استفاده بعد از رفرش
          if (typeof sessionStorage !== "undefined" && apiBase) {
            sessionStorage.setItem("NetPaApi", apiBase);
          }
          isLoadingAppSettings = false;

          this.$cookies.set("UrlAboutme", response.data.UrlAboutme);
          IsLinkPay = response.data.IsLinkPay ? response.data.IsLinkPay : false;
          IsEstelamCodeMeli = response.data.IsEstelamCodeMeli
            ? response.data.IsEstelamCodeMeli
            : false;
          sessionStorage.setItem("IsEstelamCodeMeli", IsEstelamCodeMeli);
          IsrequiredEstelamSabtAhval = response.data.IsrequiredEstelamSabtAhval
            ? response.data.IsrequiredEstelamSabtAhval
            : false;
          IsFixVarizGorohi = response.data.IsFixVarizGorohi
            ? response.data.IsFixVarizGorohi
            : false;
          IsFixVarizGorohiHasJarime = response.data.IsFixVarizGorohiHasJarime
            ? response.data.IsFixVarizGorohiHasJarime
            : false;
          MablaghKarmozdRial = response.data.MablaghKarmozdRial
            ? response.data.MablaghKarmozdRial
            : 0;
          MablaghEftetahHesab = response.data.MablaghEftetahHesab
            ? response.data.MablaghEftetahHesab
            : 0;
          NoeIdPishFarz = response.data.NoeIdPishFarz
            ? response.data.NoeIdPishFarz
            : 0;
          IsAnbohSaz = response.data.IsAnbohSaz
            ? response.data.IsAnbohSaz
            : "false";
          IsCardexPay = response.data.CardexPay
            ? response.data.CardexPay
            : false;
          HasEmza = response.data.hasEmza ? response.data.hasEmza : false;
          IsEstelamSheba = response.data.IsEstelamSheba
            ? response.data.IsEstelamSheba
            : false;
          EnableRobot = response.data.EnableRobot
            ? response.data.EnableRobot
            : false;
          sessionStorage.setItem("EnableRobot", EnableRobot);
          if (
            response.data.VahedPool &&
            response.data.VahedPool != "" &&
            response.data.VahedPool != null
          ) {
            VahedPool = response.data.VahedPool;
          } else {
            VahedPool = "ریال";
          }
          if (response.data.DownloadForm && response.data.DownloadForm != "") {
            this.$cookies.set("DownloadForm", response.data.DownloadForm);
          } else {
            this.$cookies.remove("DownloadForm");
          }
          if (response.data.RegisterForm && response.data.RegisterForm != "") {
            this.$cookies.set("RegisterForm", response.data.RegisterForm);
          } else {
            this.$cookies.remove("RegisterForm");
          }

          // console.log(Vue.prototype.URL)
        })
        .catch((error) => {
          console.log("catch error", error);

          isLoadingAppSettings = false;
        });

      return appSettingsPromise;
    };
    (Vue.prototype.$GetAppsettingsAsync = function () {
      return new Promise((success, reject) => {
        // console.log('GetAppsettingsAsync');
        var axios = require("axios");
        const config = {
          method: "GET",
          url: `${
            window.location.origin
          }/appSettings.json?nocache=${Date.now()}`,
          headers: {
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "Content-Type": "application/json",
          },
        };
        axios(config).then((response) => {
          // console.log('response.data.NetPaApi', response.data.NetPaApi)

          apiBase = response.data.NetPaApi || apiBase;
          // ذخیره در sessionStorage برای استفاده بعد از رفرش
          if (typeof sessionStorage !== "undefined" && apiBase) {
            sessionStorage.setItem("NetPaApi", apiBase);
          }

          //this.$cookies.set('IsNetPa', response.data.IsNetPa)
          // this.$cookies.set('NetPaApiUrl', response.data.NetPaApi)
          //this.$cookies.set('ApiServiceUrl', response.data.ApiServices)
          this.$cookies.set("UrlAboutme", response.data.UrlAboutme);
          //this.$cookies.set('CaptchSiteKey', response.data.CaptchSiteKey)
          IsLinkPay = response.data.IsLinkPay ? response.data.IsLinkPay : false;
          IsEstelamCodeMeli = response.data.IsEstelamCodeMeli
            ? response.data.IsEstelamCodeMeli
            : false;
          IsrequiredEstelamSabtAhval = response.data.IsrequiredEstelamSabtAhval
            ? response.data.IsrequiredEstelamSabtAhval
            : false;
          IsFixVarizGorohi = response.data.IsFixVarizGorohi
            ? response.data.IsFixVarizGorohi
            : false;
          IsFixVarizGorohiHasJarime = response.data.IsFixVarizGorohiHasJarime
            ? response.data.IsFixVarizGorohiHasJarime
            : false;
          MablaghEftetahHesab = response.data.MablaghEftetahHesab
            ? response.data.MablaghEftetahHesab
            : 0;
          NoeIdPishFarz = response.data.NoeIdPishFarz
            ? response.data.NoeIdPishFarz
            : 0;
          MablaghKarmozdRial = response.data.MablaghKarmozdRial
            ? response.data.MablaghKarmozdRial
            : 0;
          IsAnbohSaz = response.data.IsAnbohSaz
            ? response.data.IsAnbohSaz
            : "false";
          IsCardexPay = response.data.CardexPay
            ? response.data.CardexPay
            : false;
          HasEmza = response.data.hasEmza ? response.data.hasEmza : false;
          IsEstelamSheba = response.data.IsEstelamSheba
            ? response.data.IsEstelamSheba
            : false;
          if (
            response.data.VahedPool &&
            response.data.VahedPool != "" &&
            response.data.VahedPool != null
          ) {
            VahedPool = response.data.VahedPool;
          } else {
            VahedPool = "ریال";
          }
          // if (response.data.VahedPool && response.data.VahedPool != '' && response.data.VahedPool != null) {
          //   this.$cookies.set('VahedPool', response.data.VahedPool)
          // } else {
          //   this.$cookies.set('VahedPool', 'ریال')
          // }
          let NowTime = this.$GetJalaliDateTime().substring(11, 16);
          var timesplit = NowTime.split(":");
          if (timesplit[0].length < 2) {
            timesplit[0] = "0" + timesplit[0];
          }
          if (timesplit[1].length < 2) {
            timesplit[1] = "0" + timesplit[1];
          }
          NowTime = timesplit[0] + ":" + timesplit[1];
          if (
            response.data.IsMaintenance &&
            response.data.IsMaintenance == true
          ) {
            success(true);
          } else if (
            response.data.StartMaintenance &&
            response.data.EndMaintenance &&
            response.data.StartMaintenance.length > 0 &&
            response.data.EndMaintenance.length > 0
          ) {
            if (
              this.$isTimeBetween(
                response.data.StartMaintenance,
                response.data.EndMaintenance,
                NowTime,
              )
            ) {
              success(true);
            }
          }

          if (response.data.DownloadForm && response.data.DownloadForm != "") {
            this.$cookies.set("DownloadForm", response.data.DownloadForm);
          } else {
            this.$cookies.remove("DownloadForm");
          }
          if (response.data.RegisterForm && response.data.RegisterForm != "") {
            this.$cookies.set("RegisterForm", response.data.RegisterForm);
          } else {
            this.$cookies.remove("RegisterForm");
          }
          success();
        });
      });
    }),
      (Vue.prototype.$GetIsEstelamCodeMeli = function () {
        return IsEstelamCodeMeli;
      }),
      (Vue.prototype.$GetIsrequiredEstelamSabtAhval = function () {
        return IsrequiredEstelamSabtAhval;
      }),
      (Vue.prototype.$GetIsFixVarizGorohi = function () {
        return IsFixVarizGorohi;
      }),
      (Vue.prototype.$GetMablaghKarmozdRial = function () {
        return MablaghKarmozdRial;
      }),
      (Vue.prototype.$GetIsAnbohSaz = function () {
        return IsAnbohSaz;
      }),
      (Vue.prototype.$GetIsCardexPay = function () {
        return IsCardexPay;
      }),
      (Vue.prototype.$GetMablaghEftetahHesab = function () {
        return MablaghEftetahHesab;
      }),
      (Vue.prototype.$GetNoeIdPishFarz = function () {
        return NoeIdPishFarz;
      }),
      (Vue.prototype.$GetHasEmza = function () {
        return HasEmza;
      }),
      (Vue.prototype.$GetIsEstelamSheba = function () {
        return IsEstelamSheba;
      }),
      (Vue.prototype.$GetVahedPool = function () {
        return VahedPool;
      }),
      (Vue.prototype.$GetIsLinkPay = function () {
        return IsLinkPay;
      }),
      (Vue.prototype.$GetapiBase = function () {
        // اگر apiBase خالی است، ابتدا از sessionStorage بخوان
        if (!apiBase || apiBase === "") {
          if (typeof sessionStorage !== "undefined") {
            const storedApiBase = sessionStorage.getItem("NetPaApi");
            if (storedApiBase) {
              apiBase = storedApiBase;
              return apiBase;
            }
          }
          // اگر در sessionStorage هم نبود و در حال لود نیست، الان لود کن
          if (!isLoadingAppSettings) {
            this.$GetAppsettings();
          }
        }
        return apiBase;
      }),
      (Vue.prototype.$mySweetDefault = function (title, text, icon, timer) {
        this.$swal({
          title: title,
          text: text,
          icon: icon,
          position: "center",
          timer: timer,
          showConfirmButton: false,
          showCancelButton: false,
        });
      }),
      (Vue.prototype.$SetActivePasswordSecurityMode = function (value) {
        ActivePasswordSecurityMode = value;
      }),
      (Vue.prototype.$GetActivePasswordSecurityMode = function () {
        return ActivePasswordSecurityMode;
      }),
      (Vue.prototype.$setLoginImgMode = function (value) {
        loginDefaultImageMode = value;
      }),
      (Vue.prototype.$getLoginImgMode = function () {
        return loginDefaultImageMode;
      }),
      (Vue.prototype.$SetBotSetting = function (token, userName, aboutUs) {
        botToken = token;
        botUserName = userName;
        botAboutUsText = aboutUs;
      }),
      (Vue.prototype.$GetBotSetting = function () {
        var botSetting = {
          token: botToken,
          userName: botUserName,
          aboutUs: botAboutUsText,
        };
        return botSetting;
      }),
      (Vue.prototype.$mySweetDefaultTost = function (title, text, icon, timer) {
        this.$swal({
          toast: true,
          position: "center",
          showConfirmButton: false,
          timer: timer,
          icon: icon,
          title: title,
          text: text,
          timerProgressBar: true,
        });
      });
    Vue.prototype.$IsWebSiteView = async function (
      title,
      text,
      icon,
      confirmButtonText,
      cancelButtonText,
    ) {
      return new Promise((success, reject) => {
        var axios = require("axios");
        var config = {
          method: "GET",
          url: "/appSettings.json?nocache=123",
          headers: {
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "Content-Type": "application/json",
          },
        };
        axios(config).then((result) => {
          var IsWebSiteView = result.data.WebSiteView;
          if (IsWebSiteView == true) {
            success(true);
          } else {
            success(false);
          }
        });
      });
    };
    Vue.prototype.$mySweetPost = function (
      title,
      text,
      icon,
      confirmButtonText,
      cancelButtonText,
    ) {
      this.$swal({
        title: title,
        text: text,
        icon: icon,
        showCancelButton: true,
        confirmButtonColor: "#5cb85c",
        cancelButtonColor: "#1f5e48",
        confirmButtonText: confirmButtonText,
        cancelButtonText: cancelButtonText,
      }).then((result) => {
        if (result.isConfirmed) {
          // this.$clearPage();
          this.$store.state.renderComponentGrid = false;
          this.$store.state.renderComponentTree = false;
          this.$store.state.renderComponent = false;
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true;
            this.$store.state.renderComponentTree = true;
            this.$store.state.renderComponent = true;
          });
        } else {
          document.getElementById("btnCancel").click();
          this.$store.state.renderComponentGrid = false;
          this.$store.state.renderComponentTree = false;
          this.$store.state.renderComponent = false;
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true;
            this.$store.state.renderComponentTree = true;
            this.$store.state.renderComponent = true;
            // document.getElementById("btnCancel").click();
          });
        }
      });
    };

    //#region خواندن ستون های جداول
    Vue.prototype.$myAxoisGridColumns = function (
      InnerData,
      IsAction,
      IsCustomCheckBox,
    ) {
      var axios = require("axios");
      InnerData.ArryfildValue.UserId = this.$session.get("UserInfo").tblUserId;
      var data = JSON.stringify(InnerData.ArryfildValue);

      var config = {
        method: InnerData.Method,
        url: this.$GetapiBase() + InnerData.Action + "/Index",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then((response) => {
          let info;
          let List = [];
          for (let index = 0; index < response.data.length; index++) {
            info = response.data[index];
            List.push(info);
          }
          if (IsAction) {
            List.push({
              label: "عملیات ها",
              name: "id",
              slot_name: "action-slot",
              sort: false,
            });
          }
          if (IsCustomCheckBox) {
            List.push({
              label: "عملیات ها",
              name: "id",
              slot_name: "Select-slot",
              sort: false,
            });
          }

          this.$store.dispatch("SetCoolGrid", List);
          //console.log(this.List)
        })
        .catch(function (error) {
          console.log(error);
        });
    };
    //#endregion
    //#region  روش جدید خواندن ستون های جداول
    Vue.prototype.$NewGridColumns = function (
      InnerData,
      IsAction,
      IsCustomCheckBox,
      IsSort,
      IsRow,
    ) {
      var axios = require("axios");
      var data = JSON.stringify(InnerData.ArryfildValue);

      var config = {
        method: InnerData.Method,
        url: this.$GetapiBase() + InnerData.Action + "/Index",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      let List = [];
      this.$store.state.renderComponent = false;
      axios(config)
        .then((response) => {
          let info;
          if (IsRow) {
            List.push({
              label: "ردیف",
              name: "row",
              slot_name: "action-slot2",
              sort: false,
            });
          }
          for (let index = 0; index < response.data.length; index++) {
            info = response.data[index];
            IsSort == true ? (info["sort"] = true) : (info["sort"] = false);
            List.push(info);
          }
          if (this.$route.name == "SanadRizNew") {
            List.push({
              id: "1010",
              name: "FishNoRahgiri",
              visibility: true,
              width: 181,
              indexCol: 0,
              label: "ش فیش/ رهگیری",
            });
          }
          if (IsAction) {
            List.push({
              label: "عملیات ها",
              name: "id",
              slot_name: "action-slot",
              sort: false,
            });
          }
          if (IsCustomCheckBox) {
            List.push({
              label: "عملیات ها",
              name: "id",
              slot_name: "Select-slot",
              sort: false,
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {
          this.$store.state.renderComponentGrid = false;
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true;
          });
        });
      return List;
    };
    //#endregion

    //#region خواندن اطلاعات نرم افزار در بخش ثبت اطلاعات سیستم
    Vue.prototype.$myAxiosGetSoftware = function (InnerData) {
      var axios = require("axios");
      var FormData = require("form-data");
      var data = new FormData();
      if (InnerData.ArryfildValue == "" || InnerData.ArryfildValue == null) {
        data = null;
      } else {
        if (InnerData.From == "Body") {
          var ObjKey = Object.keys(InnerData.ArryfildValue);
          var ObjValue = Object.values(InnerData.ArryfildValue);
          for (let i = 0; i < ObjKey.length; i++) {
            data.append(ObjKey[i], ObjValue[i]);
          }
        } else {
          data = InnerData.ArryfildValue;
        }
      }
      var config = {
        method: InnerData.Method,
        url: this.$GetapiBase() + InnerData.Action,
        headers: {
          Authorization: "Bearer " + InnerData.Token,
        },
        data: data,
      };

      axios(config)
        .then((res) => {
          if (res.status == 200) {
            this.$store.state.DefineInfoSystem.DataSoftWare = res.data;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    };
    //#endregion

    //#region ApiServices
    //#region FindData[InnerDeta]
    Vue.prototype.$FindData = function (InnerData) {
      var axios = require("axios");
      var config = {
        method: InnerData.Method,
        url:
          this.$GetapiBase() +
          InnerData.Action +
          "/" +
          InnerData.ArryfildValue.id,
        headers: {
          Authorization: "Bearer " + InnerData.Token,
          "Content-Type": "application/json",
        },
      };
      return axios(config).then((response) => response.data);
    };
    //#endregion
    //#region GetData[InnerDeta]
    Vue.prototype.$GetData_Body = function (InnerData) {
      // this.$mySweetDefault(false,'... درحال بارگزاری اطلاعات',false,false);
      var axios = require("axios");
      var data = JSON.stringify(InnerData.ArryfildValue);

      var config = {
        method: "Get",
        url: this.$GetapiBase() + InnerData.Action,
        data: data,
        headers: {
          Authorization: "Bearer " + InnerData.Token,
          "Content-Type": "application/json",
        },
      };
      return axios(config).then((response) => response.data);
    };
    Vue.prototype.$GetData_Header = function (InnerData) {
      // this.$mySweetDefault(false,'... درحال بارگزاری اطلاعات',false,false);

      var axios = require("axios");
      var config = {
        method: "Get",
        url:
          this.$GetapiBase() +
          InnerData.Action +
          "/" +
          InnerData.ArryfildValue.Id,
        headers: {
          Authorization: "Bearer " + InnerData.ArryfildValue.Token,
          "Content-Type": "application/json",
        },
      };
      //console.log(config.url)

      return axios(config).then((response) => response.data);
    };
    //#endregion
    //#region PostData[InnerData]
    Vue.prototype.$PostData = function (InnerData) {
      // this.$mySweetDefault(false, '... درحال بارگزاری اطلاعات', false, false);
      var axios = require("axios");
      var data = JSON.stringify(InnerData.ArryfildValue);
      var config = {
        method: InnerData.Method,
        url: this.$GetapiBase() + InnerData.Action,
        headers: {
          Authorization: "Bearer " + InnerData.Token,
          "Content-Type": "application/json",
        },

        data: data,
      };
      return axios(config).then((response) => response.data);
    };

    Vue.prototype.$PostDataExternal = function (InnerData) {
      // this.$mySweetDefault(false, '... درحال بارگزاری اطلاعات', false, false);
      var axios = require("axios");
      var data = JSON.stringify(InnerData.ArryfildValue);
      var config = {
        method: InnerData.Method,
        url: InnerData.Action,
        headers: {
          Authorization: "Bearer " + InnerData.Token,
          "Content-Type":
            InnerData.Content == null ? "application/json" : InnerData.Content,
        },

        data: data,
      };
      // console.log(config)
      return axios(config).then((response) => response.data);
    };

    Vue.prototype.$PostFormDataExternal = function (InnerData) {
      // this.$mySweetDefault(false, '... درحال بارگزاری اطلاعات', false, false);
      var axios = require("axios");
      var data = InnerData.ArryfildValue;
      var config = {
        method: InnerData.Method,
        url: InnerData.Action,
        headers: {
          Authorization: "Bearer " + InnerData.Token,
          "Content-Type": "multipart/form-data",
        },
        data: data,
      };

      return axios(config).then((response) => response.data);
    };

    Vue.prototype.$PostData_netpatoken = function (Data) {
      var axios = require("axios");
      let token = Vue.prototype.$session.get("TokenNetPa");
      var config = {
        method: Data.method,
        url: this.$GetapiBase() + Data.action,
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      };
      if ((Data.arryfildValue != null) & (Data.arryfildValue != undefined)) {
        config.data = JSON.stringify(Data.arryfildValue);
      }
      // console.log(config.data)
      return axios(config).then((response) => response.data);
    };
    Vue.prototype.$PostData_new = function (
      action,
      method,
      arryfildValue,
      fromForm,
    ) {
      var axios = require("axios");
      let token = Vue.prototype.$session.get("TokenNetPa");
      var url = this.$GetapiBase() + action;
      var config = {
        method: method,
        url: this.$GetapiBase() + action,
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      };
      if ((arryfildValue != null) & (arryfildValue != undefined)) {
        config.data = JSON.stringify(arryfildValue);
      }
      if (fromForm == true) {
        config.headers = {
          Authorization: "Bearer " + token,
          "Content-Type": "multipart/form-data",
        };
        config.data = arryfildValue;
      }

      return axios(config)
        .then((response) => response.data)
        .catch((error) => {
          let errorCode = "";
          if ((error.response != null) & (error.response != undefined)) {
            errorCode = "کد " + error.response.status;
          }
          this.$mySweetDefaultTost(
            "خطای سمت سرور",
            "خطایی رخ داد",
            "error",
            2800,
          );
          throw error;
        });
    };
    Vue.prototype.$RemoveAlert = function (mess) {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-success mx-1 order-0",
          cancelButton: "btn btn-danger order-1",
        },
        buttonsStyling: false,
      });
      return new Promise(function (resolve, reject) {
        swalWithBootstrapButtons
          .fire({
            title: "اطمینان دارید؟",
            text: mess,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "بله",
            cancelButtonText: "لفو",
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              resolve(true);
            } else {
              resolve(false);
            }
          });
      });
    };

    Vue.prototype.$PostFormData = function (InnerData) {
      // this.$mySweetDefault(false, '... درحال بارگزاری اطلاعات', false, false);
      var axios = require("axios");
      var data = InnerData.ArryfildValue;
      var config = {
        method: InnerData.Method,
        url: this.$GetapiBase() + InnerData.Action,
        headers: {
          Authorization: "Bearer " + InnerData.Token,
          "Content-Type": "multipart/form-data",
        },
        data: data,
      };

      return axios(config).then((response) => response.data);
    };

    Vue.prototype.$Payment = function (
      IdNoeDargah,
      Mablagh,
      NameFamily,
      Email,
      Mobile,
      TaahodatId,
      Shenase,
      VCodetxt,
      Des,
      AzaIdVariz,
      CustCode,
      ShobeId,
      IdRepoMaster,
      CodeMeli,
      NameFamilySahebHesab,
      MobileSahebHesab,
      CodemeliSahebHesab,
    ) {
      try {
        var DataAxios_Payment = {
          ArryfildValue: "",
          Method: "Post",
          Action: "Payment",
          Token: this.$session.get("TokenNetPa"),
        };
        var ModelPayment = {
          IdNoeDargah: IdNoeDargah,
          Mablagh: Mablagh,
          NameFamily: NameFamily,
          Email: Email,
          Mobile: Mobile,
          TaahodatId: TaahodatId,
          Shenase: Shenase,
          VCodetxt: VCodetxt,
          Des: Des,
          AzaIdVariz: AzaIdVariz,
          CustCode: CustCode,
          ShobeId: ShobeId,
          IdRepoMaster: IdRepoMaster,
          CodeMeli: CodeMeli,
          NameFamilySahebHesab: NameFamilySahebHesab,
          MobileSahebHesab: MobileSahebHesab,
          CodemeliSahebHesab: CodemeliSahebHesab,
        };
        // console.log('ModelPayment', ModelPayment)
        // this.$mySweetDefaultTost("درحال انتقال به درگاه ...","", 'info', 2000);
        DataAxios_Payment.ArryfildValue = ModelPayment;

        Vue.prototype.$PostData(DataAxios_Payment).then((data) => {
          if (data.success) {
            window.location = data.responseUrl;
          } else {
            if (data.msg) {
              this.$mySweetDefault("اطلاع رسانی", data.msg, "warning", 3500);
            } else {
              this.$mySweetDefault("خطا", data.responsetxt, "error", 2000);
              this.$store.state.loadingRender = false;
            }
          }
        });
      } catch (error) {
        this.$store.state.loadingRender = false;
      }
    };

    Vue.prototype.$PostFormDataDownload = function (InnerData) {
      // this.$mySweetDefault(false, '... درحال بارگزاری اطلاعات', false, false);
      var axios = require("axios");
      var data = InnerData.ArryfildValue;
      var config = {
        method: InnerData.Method,
        url: this.$GetapiBase() + InnerData.Action,
        maxContentLength: Infinity,
        maxBodyLength: Infinity,
        responseType: "arraybuffer",
        headers: {
          Authorization: "Bearer " + InnerData.Token,
          "Content-Type": "multipart/form-data",
        },
        data: data,
      };

      return axios(config).then((response) => response.data);
    };
    Vue.prototype.$PostFormData = function (InnerData) {
      // this.$mySweetDefault(false, '... درحال بارگزاری اطلاعات', false, false);
      var axios = require("axios");
      var data = InnerData.ArryfildValue;
      var config = {
        method: InnerData.Method,
        url: this.$GetapiBase() + InnerData.Action,
        headers: {
          Authorization: "Bearer " + InnerData.Token,
          "Content-Type": "multipart/form-data",
        },
        data: data,
      };
      return axios(config).then((response) => response.data);
    };

    Vue.prototype.$FetchAzaPic = function () {
      try {
        const userInfo = this.$session && this.$session.get("UserInfoNetPa");
        const azaId = userInfo && (userInfo.wwwtblAzaId || userInfo.WwwtblAzaId);
        if (!azaId) {
          return Promise.resolve();
        }
        if (
          this.$store.state.AzaPicSrc &&
          this.$store.state.AzaPicId == azaId
        ) {
          return Promise.resolve(this.$store.state.AzaPicSrc);
        }
        if (this.$store.state.AzaPicLoading) {
          return Promise.resolve();
        }
        this.$store.state.AzaPicLoading = true;
        var formData = new FormData();
        formData.append("wwwtblAzaId", azaId);
        return this.$PostFormData({
          Method: "Post",
          Action: "SelAza/GetAzaPic",
          ArryfildValue: formData,
          Token: this.$session.get("TokenNetPa"),
        })
          .then((data) => {
            if (typeof data === "string") {
              try {
                data = JSON.parse(data);
              } catch (e) {
                return;
              }
            }
            const status = data && (data.Status || data.status);
            const img = data && (data.Img || data.img);
            if ((status === "True" || status === "true") && img) {
              const raw = String(img);
              let src = raw;
              if (raw.indexOf("data:") !== 0) {
                let mime = "image/jpeg";
                if (raw.indexOf("iVBORw0KGgo") === 0) mime = "image/png";
                else if (raw.indexOf("R0lGOD") === 0) mime = "image/gif";
                else if (raw.indexOf("UklGR") === 0) mime = "image/webp";
                src = "data:" + mime + ";base64," + raw;
              }
              this.$store.state.AzaPicSrc = src;
              this.$store.state.AzaPicId = azaId;
            }
          })
          .catch(function () {})
          .finally(() => {
            this.$store.state.AzaPicLoading = false;
          });
      } catch (e) {
        this.$store.state.AzaPicLoading = false;
        return Promise.resolve();
      }
    };

    Vue.prototype.$PutFormData = function (InnerData) {
      this.$mySweetDefault(false, "... درحال بارگزاری اطلاعات", false, false);
      var axios = require("axios");
      var data = InnerData.ArryfildValue;
      var config = {
        method: InnerData.Method,
        url: this.$GetapiBase() + InnerData.Action,
        headers: {
          Authorization: "Bearer " + InnerData.Token,
          "Content-Type": "multipart/form-data",
        },
        data: data,
      };
      return axios(config).then((response) => response.data);
    };
    //#endregion
    //#region PutData[InnerDeta]
    (Vue.prototype.$PutData_Body = function (InnerData) {
      // var idEdit = this.$store.state.idForUpdate;
      var model = InnerData.ArryfildValue;
      var axios = require("axios");
      var config = {
        method: InnerData.Method,
        url: this.$GetapiBase() + InnerData.Action,
        headers: {
          Authorization: "Bearer " + InnerData.Token,
        },
        data: model,
      };
      return axios(config).then((response) => response.data);
    }),
      (Vue.prototype.$PutData = function (InnerData) {
        var idEdit = this.$store.state.idForUpdate;
        var model = InnerData.ArryfildValue;
        var axios = require("axios");
        var config = {
          method: InnerData.Method,
          url: this.$GetapiBase() + InnerData.Action + "/" + idEdit,
          headers: {
            Authorization: "Bearer " + InnerData.Token,
          },
          data: model,
        };
        return axios(config).then((response) => response.data);
      }),
      (Vue.prototype.$PutData_tanzimatuser = function (InnerData) {
        var model = InnerData.ArryfildValue;
        var axios = require("axios");
        var config = {
          method: InnerData.Method,
          url: this.$GetapiBase() + InnerData.Action + "/",
          headers: {
            Authorization: "Bearer " + InnerData.Token,
          },
          data: model,
        };
        return axios(config).then((response) => response.data);
      });
    //#endregion
    //#region DeleteData[InnerDeta]
    //-----------------------------//Sweet:{title, text, icon, timer,RoutName}
    Vue.prototype.$DeleteData = function (InnerData, Sweet, refreshMethod) {
      var IdDelete = InnerData.ArryfildValue.id;
      this.$swal({
        title: Sweet[0],
        text: Sweet[1],
        icon: Sweet[2],
        position: "center-center",
        showConfirmButton: true,
        timer: Sweet[3],
        showCancelButton: true,
        confirmButtonColor: "#d9534f",
        cancelButtonColor: "#f0ad4e",
        confirmButtonText: "حذف",
        cancelButtonText: "انصراف",
      }).then((result) => {
        if (result.isConfirmed) {
          //Send Deta To Api After Press Success Button In SweetAlert
          this.$mySweetDefaultTost(
            false,
            "... درحال بارگزاری اطلاعات",
            false,
            false,
          );
          var axios = require("axios");
          var config = {
            method: InnerData.Method,
            url: this.$GetapiBase() + InnerData.Action + "/" + IdDelete,
            headers: {
              Authorization: "Bearer " + InnerData.Token,
              "Content-Type": "application/json",
            },
          };
          return axios(config)
            .then((data) => {
              if (data.data.status == "Ok") {
                this.$SetLog(null, 1);
                this.$mySweetDefaultTost(
                  "حذف موفق",
                  "عملیات حذف اطلاعات با موفقیت انجام شد",
                  "success",
                  3000,
                );
                if (refreshMethod) {
                  refreshMethod();
                }
                this.$store.state.renderComponent = false;
                this.$store.state.renderComponentTree = false;
                this.$store.state.renderComponentGrid = false;
                this.$store.state.renderComponentGridOneToMeny = false;
                this.$nextTick(() => {
                  this.$store.state.renderComponent = true;
                  this.$store.state.renderComponentTree = true;
                  this.$store.state.renderComponentGrid = true;
                  this.$store.state.renderComponentGridOneToMeny = true;
                });
                return true;
              } else {
                if (data.data.eNum == "2601") {
                  this.$mySweetDefaultTost(
                    "خطایی رخ داده!",
                    "امکان ثبت داده تکراری وجود ندارد. ورودی های خود را کنترل کنید ",
                    "error",
                    3000,
                  );
                } else if (data.data.eNum == "547") {
                  this.$mySweetDefault(
                    "توجه ...",
                    "به دلیل وابستگی سایر اطلاعات امکان حذف این رکورد وجود ندارد! ",
                    "error",
                    3000,
                  );
                } else {
                  this.$mySweetDefault(
                    "خطایی رخ داده است",
                    "در ثبت اطلاعات خطایی رخ داده است، با پشتیبانی تماس بگیرید" +
                      data.data.msg,

                    "error",
                    3000,
                  );
                }
                return false;
              }
            })
            .finally(() => {});
        }
      });
    };
    Vue.prototype.$DeleteDataMostaghim = function (
      InnerData,
      Sweet,
      refreshMethod,
    ) {
      var IdDelete = InnerData.ArryfildValue.id;
      var axios = require("axios");
      var config = {
        method: InnerData.Method,
        url: this.$GetapiBase() + InnerData.Action + "?id=" + IdDelete,
        headers: {
          Authorization: "Bearer " + InnerData.Token,
          "Content-Type": "application/json",
        },
      };
      axios(config).then((data) => {
        if (data.data.status == "Ok") {
          this.$SetLog(null, 1);
          this.$mySweetDefaultTost(
            "حذف موفق",
            "عملیات حذف اطلاعات با موفقیت انجام شد",
            "success",
            3000,
          );
          if (refreshMethod) {
            refreshMethod();
          }
          this.$store.state.renderComponent = false;
          this.$store.state.renderComponentTree = false;
          this.$store.state.renderComponentGrid = false;
          this.$store.state.renderComponentGridOneToMeny = false;
          this.$nextTick(() => {
            this.$store.state.renderComponent = true;
            this.$store.state.renderComponentTree = true;
            this.$store.state.renderComponentGrid = true;
            this.$store.state.renderComponentGridOneToMeny = true;
          });
          return true;
        } else {
          if (data.data.eNum == "2601") {
            this.$mySweetDefaultTost(
              "خطایی رخ داده!",
              "امکان ثبت داده تکراری وجود ندارد. ورودی های خود را کنترل کنید ",
              "error",
              3000,
            );
          } else if (data.data.eNum == "547") {
            this.$mySweetDefault(
              "توجه ...",
              "به دلیل وابستگی سایر اطلاعات امکان حذف این رکورد وجود ندارد! ",
              "error",
              3000,
            );
          } else {
            this.$mySweetDefault(
              "خطایی رخ داده است",
              "در ثبت اطلاعات خطایی رخ داده است، با پشتیبانی تماس بگیرید" +
                data.data.msg,

              "error",
              3000,
            );
          }
          return false;
        }
      });
    };
    Vue.prototype.$DeleteDataSanadMovaghat = function (InnerData, Sweet) {
      var IdDelete = InnerData.ArryfildValue.id;
      this.$swal({
        title: Sweet[0],
        text: Sweet[1],
        icon: Sweet[2],
        position: "center-center",
        showConfirmButton: true,
        timer: Sweet[3],
        showCancelButton: true,
        confirmButtonColor: "#d9534f",
        cancelButtonColor: "#f0ad4e",
        confirmButtonText: "بله",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.isConfirmed) {
          var axios = require("axios");
          var config = {
            method: InnerData.Method,
            url: this.$GetapiBase() + InnerData.Action + "/" + IdDelete,
            headers: {
              Authorization: "Bearer " + InnerData.Token,
              "Content-Type": "application/json",
            },
          };
          return axios(config)
            .then((data) => {
              if (data.data.status == "Ok") {
                this.$store.state.renderComponent = false;
                this.$store.state.renderComponentTree = false;
                this.$store.state.renderComponentGrid = false;
                this.$store.state.renderComponentGridOneToMeny = false;
                this.$nextTick(() => {
                  this.$store.state.renderComponent = true;
                  this.$store.state.renderComponentTree = true;
                  this.$store.state.renderComponentGrid = true;
                  this.$store.state.renderComponentGridOneToMeny = true;
                });
              } else {
                if (data.data.eNum == "2601") {
                  this.$mySweetDefaultTost(
                    "خطایی رخ داده!",
                    "امکان ثبت داده تکراری وجود ندارد. ورودی های خود را کنترل کنید ",
                    "error",
                    3000,
                  );
                } else if (data.data.eNum == "547") {
                  this.$mySweetDefault(
                    "توجه ...",
                    "به دلیل وابستگی سایر اطلاعات امکان حذف این رکورد وجود ندارد! ",
                    "error",
                    3000,
                  );
                } else {
                  this.$mySweetDefault(
                    "خطایی رخ داده است",
                    "در ثبت اطلاعات خطایی رخ داده است، با پشتیبانی تماس بگیرید" +
                      data.data.msg,

                    "error",
                    3000,
                  );
                }
              }
            })
            .finally(() => {});
        }
      });
    };
    Vue.prototype.$DeleteData2 = function (InnerData, Sweet) {
      var IdDelete = InnerData.ArryfildValue.id;
      this.$swal({
        title: Sweet[0],
        text: Sweet[1],
        icon: Sweet[2],
        position: "center-center",
        showConfirmButton: true,
        timer: Sweet[3],
        showCancelButton: true,
        confirmButtonColor: "#d9534f",
        cancelButtonColor: "#f0ad4e",
        confirmButtonText: "حذف",
        cancelButtonText: "انصراف",
      }).then((result) => {
        if (result.isConfirmed) {
          //Send Deta To Api After Press Success Button In SweetAlert
          this.$mySweetDefault(
            false,
            "... درحال بارگزاری اطلاعات",
            false,
            false,
          );
          var axios = require("axios");
          var config = {
            method: InnerData.Method,
            url: this.$GetapiBase() + InnerData.Action + "/" + IdDelete,
            headers: {
              Authorization: "Bearer " + InnerData.Token,
              "Content-Type": "application/json",
            },
          };
          return axios(config)
            .then((data) => {
              return data.data;
              // if (data.data.status == "Ok") {

              // //     this.$mySweetDefault(
              // //         "حذف موفق",
              // //         "عملیات حذف اطلاعات با موفقیت انجام شد",
              // //         "success",
              // //         3000
              // //     );
              // //     this.$store.state.renderComponent = false
              // //     this.$store.state.renderComponentTree = false
              // //     this.$store.state.renderComponentGrid = false
              // //     this.$store.state.renderComponentGridOneToMeny = false
              // //     this.$nextTick(() => {
              // //         this.$store.state.renderComponent = true;
              // //         this.$store.state.renderComponentTree = true;
              // //         this.$store.state.renderComponentGrid = true;
              // //         this.$store.state.renderComponentGridOneToMeny = true;
              // //     });
              // //     //   document.getElementById("btnCancel").click();
              // // } else {
              // //     if (data.data.eNum == "2601") {
              // //         this.$mySweetDefaultTost(
              // //             "خطایی رخ داده!",
              // //             "امکان ثبت داده تکراری وجود ندارد. ورودی های خود را کنترل کنید ", 'error', 3000);

              // //     } else if (data.data.eNum == "547") {
              // //         this.$mySweetDefault(
              // //             "خطایی رخ داده!",
              // //             "به دلیل وابستگی سایر اطلاعات امکان حذف این رکورد وجود ندارد! ", 'error', 3000);

              // //     } else {
              // //         this.$mySweetDefault(
              // //             'خطایی رخ داده است',
              // //             'در ثبت اطلاعات خطایی رخ داده است، با پشتیبانی تماس بگیرید' + data.data.msg,

              // //             'error',
              // //             3000
              //         // );
              //     }
            })
            .finally(() => {});
        }
      });
    };
    //#endregion
    //#region SweetYesOrNo
    Vue.prototype.$SweetQustion = function (
      title,
      text,
      icon,
      confirmButtonText,
      cancelButtonText,
      node,
      fun1,
      fun2,
    ) {
      this.$swal({
        title: title,
        text: text,
        icon: icon,
        showCancelButton: true,
        confirmButtonColor: "#1fad1f",
        cancelButtonColor: "#ad291f",
        confirmButtonText: confirmButtonText,
        cancelButtonText: cancelButtonText,
      }).then((result) => {
        if (result.isConfirmed) {
          if (node != null) {
            fun1(node);
          } else {
            fun1();
          }
        } else {
          fun2();
        }
      });
    };
    //#endregion
    //#region GetGridColumns
    Vue.prototype.$GetGridColumns = function (
      InnerData,
      IsAction,
      IsCustomCheckBox,
      func,
    ) {
      var axios = require("axios");
      var data = JSON.stringify(InnerData.ArryfildValue);

      var config = {
        method: InnerData.Method,
        url: this.$GetapiBase() + InnerData.Action + "/Index",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config).then((response) => {
        let info;
        let List = [];
        for (let index = 0; index < response.data.length; index++) {
          info = response.data[index];
          List.push(info);
        }
        if (IsAction) {
          List.push({
            label: "عملیات ها",
            name: "id",
            slot_name: "action-slot",
            sort: false,
          });
        }
        if (IsCustomCheckBox.EditMode) {
          List.push({
            label: "عملیات ها",
            name: "id",
            slot_name: "EditMode-slot",
            sort: false,
          });
        }
        if (IsCustomCheckBox.DeleteMode) {
          List.push({
            label: "عملیات ها ",
            name: "id",
            slot_name: "DeleteMode-slot",
            sort: false,
          });
        }
        func(List);
      });
    };
    //#endregion
    //#region GetDataDefultGrid
    Vue.prototype.$GetDataDefultGrid = function (InnerData) {
      // this.$mySweetDefault(false, '... درحال بارگزاری اطلاعات', false, false);
      this.$store.state.loadingRender = true;
      var axios = require("axios");
      var data = JSON.stringify(InnerData.ArryfildValue);
      var config = {
        method: InnerData.Method,
        url: this.$GetapiBase() + InnerData.Action,
        headers: {
          Authorization: "Bearer " + InnerData.Token,
          "Content-Type": "application/json",
        },
        data: data,
      };
      this.$store.state.loadingRender = true;
      axios(config)
        .then((res) => {
          if (res.status == 200) {
            if (res.data.length > 10) {
              this.$store.state.Pagnation = true;
            } else {
              this.$store.state.Pagnation = false;
            }
            this.$store.state.posts = res.data;
            for (
              let index = 0;
              index < this.$store.state.posts.length;
              index++
            ) {
              this.$store.state.posts[index]["row"] = index + 1;
            }
            this.$store.state.loadingRender = false;

            // this.$mySweetDefaultTost(false, 'بارگزاری اطلاعات موفقیت آمیز بود', 'success', 1000);
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {
          this.$store.state.renderComponentGrid = false;
          this.$nextTick(() => {
            this.$store.state.loadingRender = false;
            this.$store.state.renderComponentGrid = true;
          });
        });
    };
    //#endregion
    //#endregion

    //#region Validation
    //Class--> required
    Vue.prototype.$required = function (frm) {
      try {
        var currform = document.getElementById(frm);
        var textbox = currform.getElementsByClassName("required");
        for (let index = 0; index < textbox.length; index++) {
          if (textbox[index].tagName == "SELECT") {
            if (textbox[index].value != -1) {
              textbox[index].classList.remove("wronginput");
            } else {
              textbox[index].classList.add("wronginput");
              textbox[index].focus();
              this.$mySweetDefaultTost(
                "ورودی نا معتبر",
                "فیلد مشخص شده الزامی می باشد ",
                "error",
                1200,
              );
              return false;
            }
          }
          if (!textbox[index].value) {
            textbox[index].classList.add("wronginput");
            textbox[index].focus();
            this.$mySweetDefaultTost(
              "ورودی نا معتبر",
              "فیلد مشخص شده الزامی می باشد ",
              "error",
              1200,
            );
            return false;
          } else {
            textbox[index].classList.remove("wronginput");
          }
        }

        return true;
      } catch (error) {
        console.log("$required method error: ", error);
        return false;
      }
    };
    //Class--> required-CodeMeli
    Vue.prototype.$requiredCodeMeli = function (frm) {
      var currform = document.getElementById(frm);
      var textboxCodeMeli =
        currform.getElementsByClassName("required-CodeMeli");
      for (let index = 0; index < textboxCodeMeli.length; index++) {
        if (textboxCodeMeli[index].value.trim() == "") {
          // alert("");
          textboxCodeMeli[index].classList.add("wronginput");
          this.$mySweetDefaultTost(
            "خطا",
            "کد ملی باید 10 رقم باشد",
            "error",
            2000,
          );
          return true;
        } else {
          var allDigitEqual = [
            "0000000000",
            "1111111111",
            "2222222222",
            "3333333333",
            "4444444444",
            "5555555555",
            "6666666666",
            "7777777777",
            "8888888888",
            "9999999999",
          ];
          var txtCodeMeli = [];
          txtCodeMeli = String(textboxCodeMeli[index].value);
          if (allDigitEqual.find((element) => element == txtCodeMeli) > 0) {
            textboxCodeMeli[index].classList.add("wronginput");
            this.$mySweetDefaultTost(
              "خطا",
              "کد ملی صحیح نمیباشد ، تمام اعداد یکسان وارد شده است !",
              "error",
              2000,
            );
            return false;
          }
          var chArray = textboxCodeMeli[index].value.split("");
          var num0 = chArray[0] * 10;
          var num2 = chArray[1] * 9;
          var num3 = chArray[2] * 8;
          var num4 = chArray[3] * 7;
          var num5 = chArray[4] * 6;
          var num6 = chArray[5] * 5;
          var num7 = chArray[6] * 4;
          var num8 = chArray[7] * 3;
          var num9 = chArray[8] * 2;
          var a = chArray[9];
          var b = num0 + num2 + num3 + num4 + num5 + num6 + num7 + num8 + num9;
          var c = b % 11;
          var b_ret = (c < 2 && a == c) || (c >= 2 && 11 - c == a);
          if (b_ret == false) {
            textboxCodeMeli[index].classList.add("wronginput");
            this.$mySweetDefaultTost(
              "خطا",
              "کد ملی صحیح نمی باشد",
              "error",
              2000,
            );
            return false;
          } else {
            textboxCodeMeli[index].classList.remove("wronginput");
          }
        }
      }
      return true;
    };

    //@Input --> inputCodeMeli
    Vue.prototype.$CheckupLengthCodeMeli = function (event) {
      if (event.target.value.length > event.target.maxLength) {
        this.$store.state.TarifKarbaran.Data[0].UserCodeMeli =
          event.target.value.slice(0, event.target.maxLength);
      }
    };
    //Class--> required-Pass --> required-Pass-Confirm
    Vue.prototype.$ValidPass = function (frm) {
      const currform = document.getElementById(frm);
      const txtPassInput = currform.querySelector(".required-Pass");
      if (!txtPassInput) return true;

      const txtPass = txtPassInput.value.trim();
      const passwordRegex =
        /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;

      if (txtPass.length < 8) {
        this.$mySweetDefaultTost(
          "کلمه عبور باید حداقل ۸ کاراکتر باشد",
          "خطا",
          "error",
          4000,
        );
        return false;
      }
      if (
        !passwordRegex.test(txtPass) &&
        this.$GetActivePasswordSecurityMode() == true
      ) {
        this.$mySweetDefaultTost(
          "کلمه عبور باید شامل حروف کوچک، بزرگ، عدد و کاراکتر خاص باشد",
          "خطا",
          "error",
          4000,
        );
        return false;
      }

      return true;
    };
    //@KeyUpTxtPass
    Vue.prototype.$PassProgress = function (frm) {
      var currform = document.getElementById(frm);
      var textboxPass = currform.getElementsByClassName("required-Pass");

      var txtpass = textboxPass[0].value;
      var length = txtpass.length;
      var strength = 0;
      if (length >= 6) {
        strength = +60;
      }
      if (length == 1) {
        strength = 10;
      }
      if (length == 2) {
        strength = 20;
      }
      if (length == 3) {
        strength = 30;
      }
      if (length == 4) {
        strength = 40;
      }
      if (length == 5) {
        strength = 50;
      }
      if (txtpass.match(/[a-z]/)) {
        strength = strength + 15;
      }
      if (txtpass.match(/[A-Z]/)) {
        strength = strength + 15;
      }
      if (txtpass.match(/[0-9]/)) {
        strength = strength + 10;
      }
      //------Color Change------
      if (strength <= 25) {
        currform.querySelector("#progress-progress").style.backgroundColor =
          "#e50839";
      }
      if (strength <= 50 && strength > 25) {
        currform.querySelector("#progress-progress").style.backgroundColor =
          "#d9c709";
      }
      if (strength < 95 && strength > 50) {
        currform.querySelector("#progress-progress").style.backgroundColor =
          "#e4862c";
      }
      if (strength >= 95) {
        currform.querySelector("#progress-progress").style.backgroundColor =
          "#67b221";
      }

      currform.querySelector(".progress-bar > div").style.width =
        strength + "%";
      // currform.querySelector(".progress-bar > div").textContent = strength+"%";
    };
    //Finallyfunction For required
    Vue.prototype.$ValidForm = function (frm) {
      return (
        this.$required(frm) &&
        this.$ValidPass(frm) &&
        this.$requiredCodeMeli(frm)
      );
    };

    Vue.prototype.$ValidPersian = function (e, length) {
      if (e.target.value.length + 1 > length) {
        this.$mySweetDefaultTost(
          " محدودیت کارکتر",
          " حداکثر طول متن" + length + " کارکتر می باشد ",
          "warning",
          2000,
        );
        e.preventDefault();
      }
      let char = String.fromCharCode(e.keyCode);
      if (!/^[A-Za-z'"]+$/.test(char)) return true;
      else {
        this.$mySweetDefaultTost(
          "خطا",
          "فقط حروف فارسی مجاز است",
          "error",
          3000,
        );
        e.preventDefault();
      }
    };
    Vue.prototype.$BlockSuspiciousInput = function (e, length) {
      const value = e.target.value || "";
      const char = String.fromCharCode(e.keyCode || 0);

      // لیست کلمات مشکوک (می‌تونی کم‌وزیادش کنی)
      const suspiciousWords = [
        "select",
        "insert",
        "update",
        "delete",
        "drop",
        "alter",
        "create",
        "exec",
        "union",
        "fetch",
        "declare",
        "truncate",
        "xp_",
        "information_schema",
        "--",
        ";",
        "'",
        '"',
        "<script",
        "onerror",
        "onload",
      ];

      // جلوگیری از طول بیش از حد (مثل متد قبلی‌ات)
      if (value.length + 1 > length) {
        this.$mySweetDefaultTost(
          "محدودیت کاراکتر",
          "حداکثر طول متن " + length + " کاراکتر می‌باشد",
          "warning",
          3000,
        );
        e.preventDefault();
        e.target.value = "";
        return false;
      }

      // آماده‌سازی مقدار برای بررسی: در رویداد paste یا input، e.target.value شامل مقدار جدید است.
      const nextValue = (value + char).toLowerCase();
      const currentValue = (e.target.value || "").toLowerCase();
      // اگر nextValue طولانی‌تر است، یعنی یک کلید اضافه شده؛ در غیر این صورت از currentValue استفاده کن (برای paste و input)
      const checkValue =
        nextValue.length > currentValue.length ? nextValue : currentValue;

      // فرمت تابع برای Escape کردن کاراکترهای ویژه در regex
      const escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

      // حذف همه‌ی رخدادهای هر عبارت مشکوک
      let cleaned = checkValue;
      for (const word of suspiciousWords) {
        if (!word) continue;
        const re = new RegExp(escapeRegExp(word), "gi");
        cleaned = cleaned.replace(re, "");
      }

      if (cleaned !== checkValue) {
        this.$mySweetDefaultTost(
          "خطا امنیتی",
          `عبارت مشکوک در ورودی حذف شد`,
          "error",
          3000,
        );
        // تنظیم مقدار ورودی به مقدار تمیز شده
        e.preventDefault();
        // حفظ حالت کاربر: اعمال مقدار تمیز شده (بدون عبارات مشکوک)
        e.target.value = cleaned;
        return false;
      }

      return true;
    };

    Vue.prototype.$Validengilsh = function (e, length) {
      if (e.target.value.length + 1 > length) {
        this.$mySweetDefaultTost(
          " محدودیت کارکتر",
          " حداکثر طول متن" + length + " کارکتر می باشد ",
          "warning",
          2000,
        );
        e.preventDefault();
      }
      let char = String.fromCharCode(e.keyCode);
      if (/^[A-Za-z0-9]+$/.test(char)) return true;
      else {
        this.$mySweetDefaultTost(
          "خطا",
          "فقط حروف لاتین مجاز است",
          "error",
          2000,
        );
        e.preventDefault();
      }
    };
    (Vue.prototype.$ValidNumber = function (e, length, IsNumber) {
      if (IsNumber) {
        if (e.key != "Enter" && e.key !== "Backspace") {
          let Val = e.target.value.replace(/,/g, "").replace(/\./g, "");
          if (Val.length + 1 > length) {
            this.$mySweetDefaultTost(
              " محدویت کارکتر",
              " حداکثر طول متن" + length + " کارکتر می باشد ",
              "warning",
              2000,
            );
            e.preventDefault();
          }
        } else {
          let char = String.fromCharCode(e.keyCode);
          char = this.$b_ToPersianNumber(char);
          if (/^[0-9]+$/.test(char) || e.key == "Enter" || e.key == ".") {
            e.target.value = e.target.value.replace(/\./g, "");
            return true;
          } else {
            this.$mySweetDefaultTost(
              "خطا",
              "فقط اعداد مجاز است",
              "error",
              2000,
            );
            e.preventDefault();
          }
        }
      } else {
        if (e.key != "Enter") {
          let Val = e.target.value.replace(/,/g, "").replace(/\./g, "");
          if (Val.length + 1 > length) {
            this.$mySweetDefaultTost(
              " محدویت کارکتر",
              " حداکثر طول متن" + length + " کارکتر می باشد ",
              "warning",
              2000,
            );
            e.preventDefault();
          }
        }
        let char = String.fromCharCode(e.keyCode);
        char = this.$b_ToPersianNumber(char);
        if (/^[0-9]+$/.test(char) || e.key == "Enter") return true;
        else if (e.key == ".") {
          return true;
        } else {
          this.$mySweetDefaultTost("خطا", "فقط اعداد مجاز است", "error", 2000);
          e.preventDefault();
        }
      }
    }),
      (Vue.prototype.$b_ToPersianNumber = function (num) {
        var char = num;
        for (var i = 0; i < 10; i++) {
          char = char.replace(pn[i], en[i]);
        }
        return char;
      });
    (Vue.prototype.$ValidNumberkeyup = function (e) {
      e.target.value = e.target.value.replace(/\D/g, "");
      this.$PutCommatoInput();
    }),
      (Vue.prototype.$ValidLenght = function (e, length) {
        if (e.target.value.length + 1 > length) {
          this.$mySweetDefaultTost(
            " محدویت کارکتر",
            " حداکثر طول متن" + length + " کارکتر می باشد ",
            "warning",
            2000,
          );
          e.preventDefault();
        }
      });

    //#endregion
    Vue.prototype.$ExportUrl = function () {
      return this.$GetapiBase();
    };

    Vue.prototype.$getLocalIP = function () {
      return new Promise(function (resolve, reject) {
        // NOTE: window.RTCPeerConnection is "not a constructor" in FF22/23
        var RTCPeerConnection =
          window.RTCPeerConnection ||
          window.webkitRTCPeerConnection ||
          window.mozRTCPeerConnection;
        if (!RTCPeerConnection) {
          reject("Your browser does not support this API");
        }

        var rtc = new RTCPeerConnection({ iceServers: [] });
        var addrs = {};
        addrs["0.0.0.0"] = false;

        function grepSDP(sdp) {
          //var hosts = [];
          var finalIP = "";
          sdp.split("\r\n").forEach(function (line) {
            // c.f. http://tools.ietf.org/html/rfc4566#page-39
            if (~line.indexOf("a=candidate")) {
              // http://tools.ietf.org/html/rfc4566#section-5.13
              let parts = line.split(" "), // http://tools.ietf.org/html/rfc5245#section-15.1
                addr = parts[4],
                type = parts[7];
              if (type === "host") {
                finalIP = addr;
              }
            } else if (~line.indexOf("c=")) {
              // http://tools.ietf.org/html/rfc4566#section-5.7
              let parts = line.split(" "),
                addr = parts[2];
              finalIP = addr;
            }
          });
          return finalIP;
        }

        if (window.mozRTCPeerConnection) {
          // FF [and now Chrome!] needs a channel/stream to proceed
          rtc.createDataChannel("", { reliable: false });
        }

        rtc.onicecandidate = function (evt) {
          // convert the candidate to SDP so we can run it through our general parser
          // see https://twitter.com/lancestout/status/525796175425720320 for details
          if (evt.candidate) {
            var addr = grepSDP("a=" + evt.candidate.candidate);
            resolve(addr);
          }
        };
        rtc.createOffer(
          function (offerDesc) {
            rtc.setLocalDescription(offerDesc);
          },
          function (e) {
            console.warn("offer failed", e);
          },
        );
      });
    };

    Vue.prototype.$ResetForm = function (myForm) {
      var oInputs = new Array();
      oInputs = document.getElementById(myForm).getElementsByTagName("div");
      for (let index = 0; index < oInputs.length; index++) {
        var Out = new Array();
        Out = oInputs[index].getElementsByTagName("input");

        for (var i = 0; i < Out.length; i++) {
          if (
            Out[i].type.toLowerCase() == "text" ||
            Out[i].type.toLowerCase() == "number" ||
            Out[i].type.toLowerCase() == "password"
          ) {
            Out[i].value = "";
          }
        }
      }
    };
    //#region displayTimer
    var milisectTimer = 0;
    var secondstTimer = 10;
    Vue.prototype.$displayTimer = function () {
      if (document.getElementById("b_Timer")) {
        if (document.getElementById("b_Timer").value != "--:--") {
          if ((milisectTimer == 1 && secondstTimer == 0) || secondstTimer < 0) {
            document.getElementById("b_Timer").value = "--:--";
            window.location.href = "/";
          } else if (milisectTimer == 0) {
            milisectTimer = 60;
            secondstTimer -= 1;
          }

          milisectTimer -= 1;

          if (document.getElementById("b_Timer").value != "--:--") {
            if (milisectTimer >= 10)
              document.getElementById("b_Timer").value =
                "0" + secondstTimer + ":" + milisectTimer;
            else
              document.getElementById("b_Timer").value =
                "0" + secondstTimer + ":" + "0" + milisectTimer;
            setTimeout(() => {
              this.$displayTimer();
            }, 1000);
          }

          //bgColor = "#ffffff";
          //if (secondstTimer < 2)
          //   bgColor = "#F8BCB6";
          //else if (secondstTimer < 5)
          //   bgColor = "#E8E6B8";

          //document.getElementById("b_Timer").style.
          //      debugger;
        }
      }
    };

    Vue.prototype.$ResetTimer = function () {
      if (document.getElementById("b_Timer")) {
        milisectTimer = 0;
        secondstTimer = 10;
        document.getElementById("b_Timer").value = "10:00";
      }
    };
    //#endregion

    //#region ثبت لاگ و مقایسه دیتا قدیم و جدید
    Vue.prototype.$SetLog = function (NewData, IsDelete) {
      if (IsDelete == 0) {
        //Edit Mode
        let OldData = JSON.parse(this.$store.state.OldDataForLog);
        // console.log("NewDataCustom:",NewData);
        // console.log("OldData:",this.$store.state.OldDataForLog);
        let AllElements = document
          .getElementById(String(this.$route.name))
          .getElementsByTagName("small");

        var listLogRiz = [];
        for (let k of Object.keys(NewData && OldData)) {
          if (
            OldData[k] != NewData[k] &&
            NewData[k] != OldData[k] &&
            typeof NewData[k] != "object"
          ) {
            let LogRiz = {
              Id: 0,
              TblBnpCashLogId: 0,
              FieldName: null,
              FieldCaption: "",
              OldValue: "",
              NewValue: "",
            };
            AllElements.forEach((element) => {
              if (element.id.substring(3) == k) {
                var Lable = element.innerHTML;
                LogRiz.FieldCaption = Lable;
              }
            });
            LogRiz.FieldName = k;
            LogRiz.OldValue = OldData[k] == null ? "" : OldData[k];
            LogRiz.NewValue = NewData[k] == null ? "" : NewData[k];
            listLogRiz.push(LogRiz);
          }
        }
        //#region ثبت رویداد های سیستم
        let object = this.$store.state.objectLogInformation;
        object.UserId = this.$session.get("UserInfo").tblUserId;
        object.UserNameFamily = this.$session.get("UserInfo").namFam;

        object.FormId =
          this.$route.name.substring(0, 6) == "Detail"
            ? this.$route.name.substring(6)
            : this.$route.name;
        object.tblShobeId = this.$session.get("UserInfo").tblShobeId;
        object.FkId = NewData.Id;
        object.IsDelete = IsDelete;
        object.TblBnpCashLogRiz = listLogRiz;

        for (let index = 0; index < this.$session.get("Menu").length; index++) {
          const element = this.$session.get("Menu")[index];
          // console.log(element.RouteName)
          if (element.RouteName == object.FormId) {
            object.FormName = element.label;
          }
        }
        this.$getLocalIP().then((res) => {
          object.IpAddress = res;
        });

        // object.TblBnpCashLogRiz
        this.DataAddLogInformation.ArryfildValue = object;
        this.$PostData(this.DataAddLogInformation).then(() => {});
        //#endregion  ثبت رویداد های سیستم
      } else {
        let DataAddLogInformation = {
          ArryfildValue: {},
          Method: "post",
          Action: "UserLogInformation/b_AddRow",
          Token: this.$session.get("Token"),
        };
        //Delete Mode
        let OldData = JSON.parse(this.$store.state.OldDataForLog);
        let listLogRiz = [];
        for (let k of Object.keys(OldData)) {
          if (typeof OldData[k] != "object") {
            let LogRiz = {
              Id: 0,
              TblBnpCashLogId: 0,
              FieldName: null,
              FieldCaption: "همه فیلد ها",
              OldValue: "",
              NewValue: "",
            };

            LogRiz.FieldName = k;
            LogRiz.OldValue = OldData[k] == null ? "" : OldData[k];
            LogRiz.NewValue = "حذف گردید";
            listLogRiz.push(LogRiz);
          }
        }
        //#region ثبت رویداد های سیستم
        let object = this.$store.state.objectLogInformation;
        object.UserId = this.$session.get("UserInfo").tblUserId;
        object.UserNameFamily = this.$session.get("UserInfo").namFam;

        object.FormId =
          this.$route.name.substring(0, 6) == "Detail"
            ? this.$route.name.substring(6)
            : this.$route.name;
        object.tblShobeId = this.$session.get("UserInfo").tblShobeId;
        object.FkId = OldData.Id;
        object.IsDelete = IsDelete;
        object.TblBnpCashLogRiz = listLogRiz;

        for (let index = 0; index < this.$session.get("Menu").length; index++) {
          const element = this.$session.get("Menu")[index];
          if (element.RouteName == object.FormId) {
            object.FormName = element.label;
          }
        }
        this.$getLocalIP().then((res) => {
          object.IpAddress = res;
        });

        // object.TblBnpCashLogRiz
        DataAddLogInformation.ArryfildValue = object;
        this.$PostData(DataAddLogInformation).then(() => {});
        //#endregion  ثبت رویداد های سیستم
      }
    };
    //#endregion

    //#region سه رقم سه رقم

    Vue.prototype.$Comma3ragham = function (Number) {
      Number += "";
      Number = Number.replace(/,/g, "").replace(/\./g, "");
      // Number = Number.replace(',', '');
      // Number = Number.replace(',', '');
      // Number = Number.replace(',', '');
      // Number = Number.replace(',', '');
      // Number = Number.replace(',', '');

      // Number = Number.replace('.', '');
      // Number = Number.replace('.', '');
      // Number = Number.replace('.', '');
      // Number = Number.replace('.', '');
      // Number = Number.replace('.', '');
      var x = Number.split(".");
      var y = x[0];
      var z = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(y)) y = y.replace(rgx, "$1" + "," + "$2");
      return y + z;
    };

    Vue.prototype.$PutCommatoInput = function () {
      var mabalegh = document.getElementsByClassName("3ragham");
      mabalegh.forEach((element) => {
        while (element.value.charAt(0) === "0") {
          element.value = element.value.substring(1);
        }
        element.value = element.value.replace(/,/g, "").replace(/\./g, "");
        // element.value = element.value..replace(/\./g,' ')
        element.value = Vue.prototype.$Comma3ragham(element.value);
      });
    };

    Vue.prototype.$DotInMablagh = function (e, Lenght) {
      if (e.key == ".") {
        if (
          Lenght - e.target.value.replace(/,/g, "").replace(/\./g, "").length >=
          3
        ) {
          // console.log(e.target.value, e.target.value.replace(/\./g, ''));
          e.target.value = e.target.value.replace(/\./g, "");
          e.target.value = e.target.value.replace(/,/g, "");
          e.target.value = e.target.value + "000";
          this.$PutCommatoInput();
        } else if (
          Lenght - e.target.value.replace(/,/g, "").replace(/\./g, "").length <
          3
        ) {
          let A = Lenght;
          let B = e.target.value.replace(/,/g, "").replace(/\./g, "").length;
          let C = A - B;
          for (let index = 0; index < C; index++) {
            e.target.value = e.target.value.replace(/\./g, "");
            e.target.value = e.target.value.replace(/,/g, "");
            e.target.value = e.target.value + "0";
            this.$PutCommatoInput();
          }
        }
      }
    };
    //#endregion
    Vue.prototype.$DataURIToBlob = function (dataURI) {
      // console.log("***", dataURI);
      const splitDataURI = dataURI.split(",");
      const byteString =
        splitDataURI[0].indexOf("base64") >= 0
          ? atob(splitDataURI[1])
          : decodeURI(splitDataURI[1]);
      const mimeString = splitDataURI[0].split(":")[1].split(";")[0];

      const ia = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i++)
        ia[i] = byteString.charCodeAt(i);

      return new Blob([ia], { type: mimeString });
    };

    // گرفتن آیدی فیلد نمایش عکس و ذخیره بیس64 در تکست باکس
    Vue.prototype.$uploadInImg = function (e, imgId, Idtext) {
      const input = e.target;
      var reader = new FileReader();
      reader.onload = function (e) {
        document.getElementById(imgId).setAttribute("src", e.target.result);
        document.getElementById(Idtext).value = e.target.result;
      };
      reader.readAsDataURL(input.files[0]);
    };
    // ساخت جدول برای گزارش گیری
    Vue.prototype.$GozareshData = function (rows, col) {
      var table = [];
      var main = { TABLE1: [] };
      col.forEach((element) => {
        if (element.visibility == true) {
          table.push([element.name, element.label]);
        }
      });
      rows.forEach((element) => {
        var temp = {};
        for (let index = 0; index < table.length; index++) {
          if (element[table[index][0]] != null) {
            temp[table[index][0]] = element[table[index][0]];
          }
        }

        main.TABLE1.push(temp);
      });
      return { columns: table, data: main };
    };
    //#region خواندن فیلتر فرم
    Vue.prototype.$GetFilterAuto = function (RoutName) {
      var Rout;
      if (RoutName != "" || RoutName != null) {
        Rout = RoutName;
      } else {
        Rout = this.$route.name;
      }

      var Allelm = document
        .getElementById(this.RoutName)
        .getElementsByClassName("FilterTag-Static");

      var DataAxios_GetFilter = {
        ArryfildValue: { RName: "", tblUserGrpId: "" },
        Method: "post",
        Action: "Filter/GetAllFilters",
        Token: this.$session.get("Token"),
      };
      DataAxios_GetFilter.ArryfildValue.RName = Rout;
      DataAxios_GetFilter.ArryfildValue.tblUserGrpId =
        this.$session.get("UserInfo").tblUserGrpId;
      this.$PostData(DataAxios_GetFilter).then((data) => {
        if (data.status == "Not Ok") {
          this.$store.state[Rout].Filters = null;
          this.$SetFilterAuto(Rout);
        } else {
          var Listelement = [];
          if (Allelm.length > data.data.length) {
            let difference = Allelm.length - data.data.length;
            for (let index = difference; index > 0; index--) {
              var filter = {
                Id: 1,
                tblUserGrpId: 1,
                tblSoftwareId: 1,
                FildName: "",
                RoutName: "",
                IsShow: 0,
                IsDefault: 0,
                FildName_fa: "",
              };
              filter.FildName = Allelm[Allelm.length - index].id;
              filter.RoutName = Rout;
              filter.IsDefault =
                Allelm[Allelm.length - index].classList.contains("FilterDef");
              filter.FildName_fa =
                Allelm[Allelm.length - index].getElementsByTagName(
                  "small",
                )[0].innerText;
              filter.tblUserGrpId = this.$session.get("UserInfo").tblUserId;
              filter.tblSoftwareId =
                this.$session.get("UserInfo").tblSoftwareId;
              Listelement.push(filter);
            }
            this.$SaveFiltersInDb(Rout, Listelement);
          } else {
            this.$store.state[Rout].Filters = data.data;
            this.$store.state[Rout].CopyFilter = JSON.stringify(
              this.$store.state[Rout].Filters,
            );
          }
        }
      });
    };
    Vue.prototype.$SetFilterAuto = function (RoutName) {
      let Rout;
      if (RoutName != "" || RoutName != null) {
        Rout = RoutName;
      } else {
        Rout = this.$route.name;
      }
      if (this.$store.state[Rout].Filters == null) {
        var Listelement = [];
        var el = document
          .getElementById(Rout)
          .getElementsByClassName("FilterTag-Static");
        el.forEach((element) => {
          var filter = {
            Id: 1,
            tblUserGrpId: 1,
            tblSoftwareId: 1,
            FildName: "",
            RoutName: "",
            IsShow: 0,
            IsDefault: 0,
            FildName_fa: "",
          };
          filter.FildName = element.id;
          filter.RoutName = Rout;
          filter.IsDefault = element.classList.contains("FilterDef");
          filter.FildName_fa =
            element.getElementsByTagName("small")[0].innerText;
          filter.tblUserGrpId = this.$session.get("UserInfo").tblUserId;
          filter.tblSoftwareId = this.$session.get("UserInfo").tblSoftwareId;
          Listelement.push(filter);
        });
        this.$SaveFiltersInDb(Rout, Listelement);
      }
    };
    Vue.prototype.$ResetValueFilters = function () {
      var el = document
        .getElementById(this.$route.name)
        .getElementsByClassName("FilterTag");
      el.forEach((element) => {
        if (element.childNodes[1].childNodes.length <= 0) {
          element.childNodes[1].value = "";
        }
        if (element.childNodes[1].childNodes.length > 0) {
          element.childNodes[1].childNodes[0].value = "";
        }
      });
    };
    Vue.prototype.$SaveFiltersInDb = function (Rout, Listelement) {
      var DataAxios_SetFilter = {
        ArryfildValue: "",
        Method: "post",
        Action: "Filter/SetAllFilters",
        Token: this.$session.get("Token"),
      };
      DataAxios_SetFilter.ArryfildValue = Listelement;
      this.$PostData(DataAxios_SetFilter).then((data) => {
        this.$store.state[Rout].Filters = data.data;
        this.$store.state[Rout].CopyFilter = JSON.stringify(
          this.$store.state[Rout].Filters,
        );
      });
    };
    //#endregion
    Vue.prototype.$FormatMablaghGrid = function (rows) {
      rows.forEach((row) => {
        for (let [key, value] of Object.entries(row)) {
          for (let index = 0; index < mabalegh.length; index++) {
            const filter = mabalegh[index];
            if (key.toString().includes(filter)) {
              row[key] = this.$Comma3ragham(value);
            }
          }
        }
      });
      return rows;
    };
    Vue.prototype.$Get_FormatShomareOzv = function () {
      const format =
        this.$session.get("UserInfo").codeShobe.trim() +
        this.$session
          .get("b_SetShomareOzvMask")
          .trim()
          .substring(3, 4)
          .replaceAll("0", "#") +
        this.$session
          .get("b_SetShomareOzvMask")
          .trim()
          .substring(4)
          .replaceAll("0", "#"); // 111-000001
      return format;
    };
    Vue.prototype.$Get_FormatVcode = function () {
      const formatVcode =
        this.$session.get("UserInfo").codeShobe.trim() +
        this.$session
          .get("b_SetVCodeMask")
          .trim()
          .substring(3, 4)
          .replaceAll("0", "#") +
        this.$session
          .get("b_SetVCodeMask")
          .trim()
          .substring(4, 6)
          .replaceAll("0", "#") +
        this.$session
          .get("b_SetVCodeMask")
          .trim()
          .substring(6, 7)
          .replaceAll("0", "#") +
        this.$session
          .get("b_SetVCodeMask")
          .trim()
          .substring(7)
          .replaceAll("0", "#"); //111-01-000001
      return formatVcode;
    };
    Vue.prototype.$AddZero = function (e) {
      // در جدول ثبت سند فیلدهای غیر عددی نباید صفر شوند
      if (Adad.includes(e.target.name)) {
        if (e.target.value != "0" && e.target.value == "") {
          e.target.value = "0";
        }
      }
    };
    Vue.prototype.$RemoveZero = function (e) {
      if (e.target.value == "0" && e.target.value != "") {
        e.target.value = "";
      }
    };

    Vue.prototype.$AzaPasAndJari = function (row) {
      this.$store.state.AzaPasAndJari.RowData[0] = row;
      this.$router.push({ name: "AzaPasAndJari" });
    };
    Vue.prototype.$AzaTashilat = function (row) {
      this.$store.state.AzaTashilat.CopyRowData[0] = row;
      this.$store.state.AzaTashilat.RowData[0] = row;
      this.$router.push({ name: "AzaTashilats" });
    };

    Vue.prototype.$b_InvertCode = function (b_code, b_jodakonande) {
      if (b_jodakonande != "") {
        var b_CodeSplit = b_code.split(b_jodakonande);
        var b_InvCode = "";
        for (let index = 0; index < b_CodeSplit.length; index++) {
          b_InvCode +=
            b_CodeSplit[b_CodeSplit.length - 1 - index] + b_jodakonande;
        }
        return b_InvCode.slice(0, -1);
      } else {
        return b_code;
      }
    };

    Vue.prototype.$b_GetMahName = function (b_Mah) {
      if (b_Mah != "") {
        switch (b_Mah) {
          case "01":
            return "فروردين";
          case "02":
            return "ارديبهشت";
          case "03":
            return "خرداد";
          case "04":
            return "تير";
          case "05":
            return "مرداد";
          case "06":
            return "شهريور";
          case "07":
            return "مهر";
          case "08":
            return "آبان";
          case "09":
            return "آذر";
          case "10":
            return "دي";
          case "11":
            return "بهمن";
          case "12":
            return "اسفند";
        }
      }
    };

    //فقط برای دریافت و پرداخت
    Vue.prototype.$AddSumRow = function (rows) {
      if (rows[rows.length - 2].ISsum) {
        rows.splice(rows.length - 2, 1);
      }
      var emptyOBJ = JSON.parse(JSON.stringify(rows[0]));
      //ساخت یک سطر خالی برای ذخیره جمع اعداد
      Object.entries(emptyOBJ).forEach(([key, value]) => {
        emptyOBJ[key] = value;
        emptyOBJ[key] = null;
      });
      for (var i = 0; i < rows.length; i++) {
        var element = rows[i];
        if (!element.ISsum) {
          Object.entries(element).forEach(([key, value]) => {
            if (mabalegh.includes(key)) {
              if (emptyOBJ[key] != null) {
                emptyOBJ[key] = emptyOBJ[key] + Number(value.replace(/,/g, ""));
              } else {
                emptyOBJ[key] = 0 + Number(value.replace(/,/g, ""));
              }
            }
          });
        }
        emptyOBJ.ISsum = true;
      }
      rows.push(emptyOBJ);
      return rows;
    };

    Vue.prototype.$AddSumRowNormal = function (rows) {
      var emptyOBJ = JSON.parse(JSON.stringify(rows[0]));
      //ساخت یک سطر خالی برای ذخیره جمع اعداد
      Object.entries(emptyOBJ).forEach(([key, value]) => {
        emptyOBJ[key] = value;
        emptyOBJ[key] = null;
      });
      for (var i = 0; i < rows.length; i++) {
        var element = rows[i];
        if (!element.ISsum) {
          console.log("ELEMENT", element);
          Object.entries(element).forEach(([key, value]) => {
            console.log("key", key);
            console.log("value", value);
            if (mabalegh.includes(key)) {
              console.log(key);
              console.log(emptyOBJ[key]);
              if (emptyOBJ[key] != null && emptyOBJ[key]) {
                emptyOBJ[key] = emptyOBJ[key] + Number(value.replace(/,/g, ""));
              } else {
                emptyOBJ[key] = 0 + Number(value.replace(/,/g, ""));
              }
            }
          });
        }
        emptyOBJ.ISsum = true;
      }
      rows.push(emptyOBJ);
      return rows;
    };
    Vue.prototype.$Mab2persianToman = function (rial) {
      var Mab = rial.replace(/,/g, "");
      Mab = Mab / 10;
      return Num2persian(Mab) + " تومان ";
    };
    Vue.prototype.$Mab2persianRial = function (rial) {
      var Mab = rial.replace(/,/g, "");
      Mab = this.$b_ToPersianNumber(Mab);
      return Num2persian(Mab) + " " + this.$GetVahedPool();
    };
    Vue.prototype.$Gateway = function (wwwtblShobeid) {
      var DataAxiosRow = {
        ArryfildValue: {
          Id:
            wwwtblShobeid && wwwtblShobeid > 0
              ? wwwtblShobeid
              : this.$session.get("UserInfoNetPa")
              ? this.$session.get("UserInfoNetPa").wwwtblShobeId
              : 0,
          Token: this.$session.get("UserInfoNetPa").token,
        },
      };
      DataAxiosRow.Action = "GetGateway";
      DataAxiosRow.Method = "GET";
      return this.$GetData_Header(DataAxiosRow).then((data) => data);
    };
    Vue.prototype.$GatewayOld = function (wwwtblShobeid) {
      var DataAxiosRow = {
        ArryfildValue: {
          Id:
            wwwtblShobeid && wwwtblShobeid > 0
              ? wwwtblShobeid
              : this.$session.get("UserInfoNetPa")
              ? this.$session.get("UserInfoNetPa").wwwtblShobeId
              : 0,
        },
      };
      DataAxiosRow.Action = "GatewayOld";
      DataAxiosRow.Method = "GET";
      return this.$GetData_Header(DataAxiosRow).then((data) => data);
    };
    Vue.prototype.$Encryption = function (strToEnc) {
      if (!strToEnc) return "";
      if (strToEnc == "") return "";
      var CryptoJS = require("crypto-js");
      var key = CryptoJS.enc.Utf8.parse("7061737323313233");
      var iv = CryptoJS.enc.Utf8.parse("7061737323313233");
      var encrypted = CryptoJS.AES.encrypt(
        CryptoJS.enc.Utf8.parse(strToEnc),
        key,
        {
          keySize: 128 / 8,
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        },
      );
      return encrypted.toString();
    };
    Vue.prototype.$NetpaAccessPage = function () {
      var access = this.$session
        .get("AccessMenu")
        .filter((x) => x.routeName == this.$route.name);
      if (access.length == 1) {
        if (!access[0].isMenu) {
          this.$router.go(-1);
          this.$mySweetDefaultTost(
            " خطا",
            " شما اجازه دسترسی به صفحه" + access[0].name + "  را ندارید!!",
            "error",
            2000,
          );
        }
      }
    };
    Vue.prototype.$IPStatic = function () {
      try {
        var axios = require("axios");

        var config = {
          method: "post",
          url: "https://api.myip.com",
          headers: {
            "Content-Type": "application/json",
          },
          data: null,
        };

        return axios(config);
      } catch (error) {}
    };
    Vue.prototype.$GetipClient = function () {
      try {
        var axios = require("axios");

        var config = {
          method: "get",
          url: apiBase + "client/get-ip",
          headers: {},
        };

        return axios(config);
      } catch (error) {}
    };
    Vue.prototype.$scrollToTop = function () {
      var btnTop = document.querySelector("#goTop");
      var btnReveal = function () {
        var position = document.querySelector("#position");
        position.innerHTML = window.scrollY + "px";
        if (window.scrollY >= 300) {
          btnTop.classList.add("is-visible");
        } else {
          btnTop.classList.remove("is-visible");
        }
      };
      var TopscrollTo = function () {
        if (window.scrollY != 0) {
          setTimeout(function () {
            window.scrollTo(0, window.scrollY - 30);
            TopscrollTo();
          }, 5);
        }
      };
      window.addEventListener("scroll", btnReveal);
      btnTop.addEventListener("click", TopscrollTo);
    };
    Vue.prototype.$Netpa_AddToCart = function (
      itemCart,
      ObjectName,
      PersianObjectName,
      IsCardex,
    ) {
      var cart = this.$store.state.Netpa_Cart;
      let Find = null;
      for (let index = 0; index < cart.length; index++) {
        if (cart[index].Name == ObjectName) {
          Find = cart[index];
        }
      }
      if (Find == null) {
        var obj = {
          Name: ObjectName,
          lbl: PersianObjectName,
          item: [],
        };
        obj.item.push(JSON.parse(JSON.stringify(itemCart)));
        cart.push(obj);
        this.$mySweetDefaultTost(
          "عملیات موفق",
          "آیتم مورد نظر شما به لیست اقساط اضافه گردید ",
          "success",
          600,
        );
      }
      if (Find != null) {
        var findItem = false;
        for (let index = 0; index < cart.length; index++) {
          if (cart[index].Name == ObjectName) {
            for (let jndex = 0; jndex < cart[index].item.length; jndex++) {
              if (cart[index].item[jndex].id == itemCart.id) {
                findItem = true;
              }
            }
            if (findItem == false) {
              cart[index].item.push(JSON.parse(JSON.stringify(itemCart)));
              this.$mySweetDefaultTost(
                "عملیات موفق",
                "آیتم مورد نظر شما به لیست اقساط اضافه گردید ",
                "success",
                600,
              );
            } else {
              if (IsCardex && IsCardex == true) {
                cart[index].item.push(JSON.parse(JSON.stringify(itemCart)));
                this.$mySweetDefaultTost(
                  "عملیات موفق",
                  "آیتم مورد نظر شما به لیست اقساط اضافه گردید ",
                  "success",
                  600,
                );
              } else {
                this.$mySweetDefault(
                  "عملیات ناموفق",
                  "آیتم مورد نظر شما در لیست پرداخت وجود دارد",
                  "error",
                  1500,
                );
              }
            }
          }
        }
      }
    };
    Vue.prototype.$DecryptionWithCryptoJS = function (cipher) {
      var CryptoJS = require("crypto-js");
      const key = CryptoJS.enc.Utf8.parse("7061737323313233");
      const iv1 = CryptoJS.enc.Utf8.parse("7061737323313233");
      const plainText = CryptoJS.AES.decrypt(cipher, key, {
        keySize: 16,
        iv: iv1,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      return plainText.toString(CryptoJS.enc.Utf8);
    };
    Vue.prototype.$OsName = function () {
      var userAgent = window.navigator.userAgent,
        platform = window.navigator.platform,
        macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"],
        windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
        iosPlatforms = ["iPhone", "iPad", "iPod"],
        os = null;

      if (macosPlatforms.indexOf(platform) !== -1) {
        os = "Mac OS";
      } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = "iOS";
      } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = "Windows";
      } else if (/Android/.test(userAgent)) {
        os = "Android";
      } else if (!os && /Linux/.test(platform)) {
        os = "Linux";
      }

      return os;
    };
    Vue.prototype.$PostDataAPISERVICE = function (InnerData) {
      // this.$mySweetDefault(false, '... درحال بارگزاری اطلاعات', false, false);
      var axios = require("axios");
      var data = InnerData.ArryfildValue;
      var config = {
        method: "POST",
        url: this.$cookies.get("ApiServiceUrl"),
        data: data,
        headers: {
          "Content-Type": "application/json",
        },
      };
      return axios(config).then((response) => response.data);
    };
    Vue.prototype.$GetJalaliDateTime = function (InnerData) {
      var Dt = moment().format("jYYYY/jMM/jDD H:mm");
      return Dt;
    };
    Vue.prototype.$GetJalaliDate = function (InnerData) {
      var D = moment().format("jYYYY/jMM/jDD");
      return D;
    };
    Vue.prototype.$GetTasveye = function (TaahodatId, ShobeId) {
      return new Promise((success, reject) => {
        var DataAxiosRow = {
          ArryfildValue: "",
          Method: "Post",
          Action: "LoanCardex",
          Token: "",
        };

        const formData = new FormData();
        formData.append("TaahodatId", TaahodatId);
        formData.append("ShobeId", ShobeId);
        DataAxiosRow.ArryfildValue = formData;

        this.$PostFormData(DataAxiosRow)
          .then((data) => {
            if (data.length) {
              var mandeGhest = 0;
              var mablaghKarmozd1 = 0;
              var mablaghKarmozd2 = 0;

              for (let index = 0; index < data.length; index++) {
                mablaghKarmozd1 +=
                  data[index].tblSanadRizIdParGhest == null &&
                  data[index].tarixGhest >= this.$GetJalaliDate()
                    ? Number(data[index].mablaghKarmozd1)
                    : 0;
                mablaghKarmozd2 +=
                  data[index].tblSanadRizIdParGhest == null &&
                  data[index].tarixGhest >= this.$GetJalaliDate()
                    ? Number(data[index].mablaghKarmozd2)
                    : 0;
                mandeGhest +=
                  data[index].shomareSanad == null &&
                  data[index].tarixSanad == null
                    ? Number(data[index].mandeGhest)
                    : 0;
              }
              this.mablaghKarmozd1 = mablaghKarmozd1;
              this.mablaghKarmozd2 = mablaghKarmozd2;
              this.mandeGhest = mandeGhest;
              GetTasveye.mabTasveye =
                Number(this.mandeGhest) -
                Number(this.mablaghKarmozd1 + this.mablaghKarmozd2);
              GetTasveye.sumKarmozd = Number(
                this.mablaghKarmozd1 + this.mablaghKarmozd2,
              );
            }
          })
          .finally(() => {
            success(GetTasveye);
          });
      });
    };
    //ارسال همه پیامکهای TBLSms  (فقط اونهایی که اماده به ارسال هستند)
    Vue.prototype.$SendSmsAmadeha = function () {
      var AxiosGet = {
        ArryfildValue: "",
        Method: "Get",
        Action: "SendSmsOnWcf",
        Token: this.$session.get("Token"),
      };
      this.$GetData_Body(AxiosGet).then((data) => {
        if (data == "Ok") {
          this.$mySweetDefaultTost(
            "ارسال موفق",
            "پیامک برای عضو شما ارسال گردید ",
            "success",
            2000,
          );
        }
      });
    };
    Vue.prototype.$IsNetPa = function () {
      //console.log(this.$cookies.get('IsNetPa'))
      return this.$cookies.get("IsNetPa") == "true";
    };
    Vue.prototype.$AutoCloseMenuForMobile = function () {
      const vw = Math.max(
        document.documentElement.clientWidth || 0,
        window.innerWidth || 0,
      );

      if (vw < 1080) {
        window.addEventListener("click", this.MenuClickhandler);

        var menus = document.querySelectorAll("li a span");
        menus.forEach((element) => {
          if (element.classList.contains("matn")) {
            element.classList.remove("mr-3");
            element.classList.add("font-small");
          }
        });
      }
    };
    Vue.prototype.$isTimeBetween = function (startTime, endTime, targetTime) {
      // Parse the input strings to Date objects
      startTime = new Date("2000-01-01T" + startTime + ":00");
      endTime = new Date("2000-01-01T" + endTime + ":00");
      targetTime = new Date("2000-01-01T" + targetTime + ":00");

      // Check if the target time is between the start and end times
      if (endTime > startTime) {
        return startTime <= targetTime && targetTime <= endTime;
      } else {
        // Handle the case where the end time is on the next day
        return startTime <= targetTime || targetTime <= endTime;
      }
    };

    Vue.prototype.$SendData_HeaderToUrl = function (InnerData) {
      var axios = require("axios");
      let URL = InnerData.Action + "?";

      for (var key in InnerData.ArryfildValue) {
        URL = URL + key + "=" + InnerData.ArryfildValue[key] + "&";
      }
      URL = URL.substring(0, URL.length - 1);
      var config = {
        method: "Get",
        url: URL,
        headers: {
          Authorization: "Bearer " + this.$session.get("TokenNetPa"),
          "Content-Type": "application/json",
        },
      };

      return axios(config).then((response) => response.data);
    };
  },
};

export default GlobalPlugin;
